<template>
  <div class="flex flex-col gap-2">
    <ProjectNavigation ref="project-navigation" :view="'sort'"></ProjectNavigation>
    <PageModiTab :project-id="projectId" :magazine-id="magazineId" :page-position="pagePosition"
                 :market-id="marketId"></PageModiTab>
    <div class="flex">
      <MouseDebug v-if="false"></MouseDebug>
      <template class="flex flex-col flex-grow pr-[10px]">
        <!--
        <draggable class="overflow-auto" :animation="200" v-model="copyVirtualIds" @change="saveProductState">
          <div v-for="(virtualId, index) in copyVirtualIds" :key="virtualId" :data-ui="'sort-bars-group-'+ index">
            <div class="bg-trader-dark-gray  mb-1 p-2 px-4 w-full mt-2 flex cursor-move"
                 :class="{'bg-trader-red' : modified}">

              <div class="mr-4 flex flex-col gap-2 "><span>{{positionsTitle[index] }}.</span><i class="fa-solid fa-bars"></i></div>
              <draggable group="people" class="overflow-auto flex-grow" :animation="200" @change="saveProductState"
                         v-model="productsGroupedByVirtualId[virtualId]" :key="productsGroupedByVirtualId">
                <div v-for="(product, i) in productsGroupedByVirtualId[virtualId]" :key="product.productId">

                  <ProductHeader :position-title="numberToAlphabetChar(i+1)" v-if="product.productId > 0"
                                 class="bg-trader-gray dark:bg-trader-light-gray mt-1" :formular-id="formId"
                                 :product="product" :visible="visible" :show-caret="false"
                                 :data-ui="'sort-products-' + index"></ProductHeader>
                </div>
              </draggable>
            </div>
          </div>
        </draggable>
        -->
        <draggable class="overflow-auto" :animation="200" v-model="sortProducts" @change="saveProductState">
          <div v-for="(sort, index) in sortProducts" :key="sort.virtualId" :data-ui="'sort-bars-group-'+ index">
            <div class="bg-trader-dark-gray  mb-1 p-2 px-4 w-full mt-2 flex cursor-move"
                 :class="{'bg-trader-red' : modified}">
              <div class="mr-4 flex flex-col gap-2 "><span>{{ sort.positionTitle }}.</span><i
                  class="fa-solid fa-bars"></i></div>
              <draggable group="people" class="overflow-auto flex-grow" :animation="200" @change="saveProductState"
                         v-model="sort.productInfo" :key="sort.productId">
                <div v-for="(p, i) in sort.productInfo" :key="p.productId">
                  <ProductHeader :position-title="numberToAlphabetChar(i+1)" v-if="p.productId > 0"
                                 class="bg-trader-gray dark:bg-trader-light-gray mt-1" :formular-id="formId"
                                 :product="products.find(item => item.productId === p.productId)" :visible="visible"
                                 :show-caret="false"
                                 :data-ui="'sort-products-' + index"></ProductHeader>
                </div>
              </draggable>
            </div>
          </div>
        </draggable>
      </template>
      <div class="flex flex-col gap-2">
        <div v-if="page?.marketId > 0" class="w-full bg-primary p-2">
          <p class="mb-2">Märkte:</p>
          <div class="grid grid-cols-8 text-center">
            <div v-if="marketList?.length > 0" v-for="market in marketList.filter(item => item.isActive)"
                 v-bind:title="market.description"
                 @click="openMarket(market.marketId)"
                 class="font-bold p-0.5 cursor-pointer hover:bg-trader-blue hover:text-white"
                 :class="{'bg-trader-blue text-white': market.marketId == marketId}"
                 v-bind:key="market">
              <span>
                {{ market.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <button data-ui="set-save-back"
                  class="bg-trader-gray text-trader-darkest-gray w-full p-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
                  @click="sortReset">
            Sortierung zurücksetzen
          </button>
          <button data-ui="sort-save"
                  class="bg-trader-green text-trader-dark-green w-full p-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
                  @click="sortSave">
            Sortierung speichern
          </button>
        </div>
        <object v-if="page?.pageId > 0 " :key="page?.pageId"
                type="image/svg+xml" rel="pagePreview"
                style="display:inline-block;position:relative; overflow:hidden;" :style="pagePreviewStyleObject"
                :data="'/api/v3/preview/page/' + page?.pageId + '?callback=pagepreview&random='+random+'&show_numbers=true'">
          <param name="type" value="image/svg+xml">
        </object>
        <!-- more buttons -->
        <div class="flex mt-1 gap-1">
          <div @click="openPagePreview" title="Vorschau vergrößern"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer">
            <i class="fa-solid fa-magnifying-glass-plus leading-8"></i> <!-- Vorschau zeigen icon--->
          </div>
        </div>
      </div>
    </div>
    <!--
        <div class="flex-grow mt-1" v-for="product in products" :key="product">
          <div class="bg-trader-gray mb-1">
            <ProductHeader :formular-id="formId" :product="product" :visible="visible"></ProductHeader>
          </div>
        </div>
   -->
  </div>
</template>

<script>
import ProjectNavigation from "@/components/ProjectNavigation/ProjectNavigation.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import ProductHeader from "@/components/ProductFormular/ProductHeader.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import router from "@/router";
import {VueDraggableNext} from "vue-draggable-next";
import {eventBus} from "@/application/EventBus";
import ShowPreview from "@/components/Preview/ShowPreview.vue";
import PageModiTab from "@/components/PageModiTab/PageModiTab.vue";
import MouseDebug from "@/components/MouseDebug/MouseDebug.vue";
import db from "@/application/db";
import {query} from "@/graphql";

export default {
  name: "SortView",
  components: {
    MouseDebug,
    PageModiTab,
    draggable: VueDraggableNext,
    ProductHeader,
    ProductFormular,
    AccordionItem,
    Accordion,
    ProjectNavigation
  },
  data() {


    return {
      productHeader: {
        productCustomFields: [
          {field: "position", value: "#"},
          {field: "article_number", value: "Art.Nr."},
          {field: "tg_name", value: "Produkttext"},
          {field: "quantity", value: "Menge"},
          {field: "quantity_2nd_field", value: "Inhalt"},
          {field: "unit", value: "Einheit"},
          {field: "package_type", value: "Verp"},
          {field: "price_per_unit", value: "Preis"},
          {field: "price", value: "Netto"},
          {field: "vat", value: "MwSt"}
        ]
      },
      projectId: null,
      magazineId: null,
      pagePosition: null,
      marketId: null,
      formNames: [],
      formId: 1,
      visible: true,
      products: [],
      sortedProducts: [],
      productsGroupedByVirtualId: [],
      positionData: [],
      header: [],
      positionsTitle: [],
      data: [],
      virtualIds: [],
      copyVirtualIds: [],
      marketList: [],
      pagePreviewStyleObject: {
        height: '1000px',
      },
      sortProducts: [],
      modified: false,
      random: Math.random(),
    }
  },
  computed: {
    ...mapState({
      pageId: state => state.pageId,
      productId: state => state.productId,
    }),
    ...mapState('page', ['page']),
    ...mapGetters('page', ['pageSide']),
    ...mapGetters('page', ['isNonFood']),
    ...mapGetters('page', ['fixedPositionProducts']),
  },
  methods: {
    ...mapActions('page', ['fetchPage']),
    async getAllMarkets() {
      const query = gql`
        query getAllMarkets {
          getAllMarkets  {
            marketId
            name
            description
            isActive
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({query});
        this.marketList = data.getAllMarkets;
      } catch (error) {
        console.error(error);
      }
    },
    openMarket(marketId) {
      router.push('/sort/' + this.projectId + "/" + this.magazineId + "/" + this.pagePosition + "/" + marketId);
    },


    numberToAlphabetChar(zahl) {
      let buchstaben = "";
      while (zahl > 0) {
        let modulo = (zahl - 1) % 26;
        buchstaben = String.fromCharCode(97 + modulo) + buchstaben; // 97 ist der ASCII-Wert von 'a'
        zahl = Math.floor((zahl - modulo) / 26);
      }
      return buchstaben;
    },

    moveProduct(event, virtualId) {
      if (event.added) {
        for (let i = 0; i < this.products?.length; i++) {
          if (this.products[i].productId === event.added.element.productId) {
            this.products[i].placeholderId = virtualId;
          }
        }
      }
    },
    openPagePreview() {
      eventBus.openModal(ShowPreview, {
        pageId: this.page.pageId,
      }, {fullSize: true});
    },

    async saveProductState() {
      try {

        // Hole die existierenden virtualIDs aus dem aktuellen Zustand
        const currentIDs = this.sortProducts.map(item => item.virtualId);
        const currenTitles = this.sortProducts.map(item => item.positionTitle);

        const sortedIDs = [...currentIDs].sort((a, b) => a - b);


        /// order currenTitles by There value 1,5,2,3,4 => 1,2,3,4,5
        currenTitles.sort((a, b) => a - b);

        this.sortProducts.forEach((item, index) => {
          item.virtualId = sortedIDs[index];
          item.positionTitle = currenTitles[index];
          item.productInfo.forEach((product, pI) => {
            product.virtualId = sortedIDs[index]
            product.productPosition = pI + 1
          });
        });



        let saveData = JSON.parse(JSON.stringify(this.sortProducts))

        this.modified = true;
        await db.transaction('rw', db.productPositionChanges, async () => {
          const existingField = await db.productPositionChanges
              .where('magazineId').equals(this.magazineId)
              .and(field => field.pagePosition === this.pagePosition && field.type === 'position')
              .first();
          if (!existingField) {
            await db.productPositionChanges.add({
              projectId: this.projectId,
              magazineId: this.magazineId,
              pagePosition: this.pagePosition,
              type: 'position',
              key: 'position',
              value: saveData
            });
          } else {
            await db.productPositionChanges.update(existingField.id, {
              value: saveData
            });
          }
        });
      } catch (err) {
        console.error('Error saving product state:', err);
      }
    },
    async getTeamForUser() {
      const [data, err] = await query.getPurchaserForCurrentUser();
      if (err) {
        console.error('Error getting purchaser for current user:', err);
        return;
      }

    },
    async getPage() {
      this.fetchPage({
        magazineId: this.magazineId,
        pagePosition: this.pagePosition,
        marketId: this.marketId || 0,
      }).then(async () => {
        const [data, err] = await query.getSortedProducts(this.page.pageId);
        if (err) {
          console.error(err);
          return;
        }
        this.products = this.fixedPositionProducts;

        this.sortProducts = data;


        const productPositions = await db.productPositionChanges
            .where('magazineId').equals(this.magazineId)
            .and(field => field.pagePosition === this.pagePosition).toArray();

        if (productPositions.length > 0) {
          this.sortProducts = productPositions[0].value;
        }
      })

      /*
        this.fetchPage({
          magazineId: this.magazineId,
          pagePosition: this.pagePosition,
          marketId: this.marketId || 0,
        }).then(async () => {

          this.copyVirtualIds = [];
          this.virtualIds = [];


          const productPositions = await db.productPositionChanges
              .where('magazineId').equals(this.magazineId)
              .and(field => field.pagePosition === this.pagePosition).toArray();




          if (productPositions.length > 0) {

            let sorted = [];
            let placeholderPosition = {};
            productPositions[0]?.value.forEach((item, index) => {
              this.page.products.forEach((item) => {
                if (!this.virtualIds.includes(item.placeholderId)) {
                  this.virtualIds.push(item.placeholderId);
                  this.copyVirtualIds.push(item.placeholderId);
                }
              });
                  this.page.products.forEach((product, pIndex) => {
                    if (product.productId === item.productId) {


                      product.placeholderId = item.virtualId;
                      product.productPosition = item.productPosition;
                      sorted.push(product);
                      placeholderPosition[pIndex] = product.placeholderPosition;
                      //productPosition[pIndex] = item.productPosition;
                    }
                  });
            });

            //apply position title to sorted products
            sorted.forEach((product, index) => {
              product.placeholderPosition = placeholderPosition[index];
             // product.productPosition = productPosition[index];
            });

            this.page.products = sorted;
            this.modified = true;
          }else{
            this.page.products.forEach((item) => {
              if (!this.virtualIds.includes(item.placeholderId)) {
                this.virtualIds.push(item.placeholderId);
                this.copyVirtualIds.push(item.placeholderId);
              }
            });

          }


          this.products = this.fixedPositionProducts;




          let virtualIds = [];
          this.products.forEach((product) => {
            if (!virtualIds.includes(product.placeholderId)) {
              this.positionsTitle.push(product.positionTitle);
              virtualIds.push(product.placeholderId);
            }
          });

          // remove letters from position title
          this.positionsTitle = this.positionsTitle.map((item) => {
            return String(item).replace(/[^0-9]/g, '');
          });


          this.productsGroupedByVirtualId = this.products.reduce((acc, product) => {
            if (!acc[product.placeholderId]) {
              acc[product.placeholderId] = [];
            }
            acc[product.placeholderId].push(product);
            return acc;
          }, {});

          this.random = Math.random();

          this.getFormNames();
        });
          */

    },
    async sortReset() {
      this.random = Math.random();
      await db.productPositionChanges
          .where('magazineId').equals(this.magazineId)
          .and(field => field.pagePosition === this.pagePosition).delete();
      this.modified = false;
      await this.getPage();
    },
    async sortSave() {

      const productPositions = await db.productPositionChanges
          .where('magazineId').equals(this.magazineId)
          .and(field => field.pagePosition === this.pagePosition).toArray();


      let data = [];
      productPositions[0].value.forEach((item) => {
        item.productInfo.forEach((product) => {
          if (product.productId !== 0) {
            data.push({
              productId: product.productId,
              virtualId: product.virtualId,
              productPosition: product.productPosition,
              articleNumber: product.articleNumber,
            });
          }
        });
      });

      const sortData = {
        sortProducts: data,
        pageId: this.page.pageId,
      };


      const mutation = gql`
          mutation sortProducts($sort: [SortInputs]!) {
            sortProducts(sort: $sort) {
              success
            }
          }
          `;
      try {
        const variables = {
          sort: sortData,
        };
        const {data} = await apolloClient.mutate({mutation, variables});

        this.random = Math.random();
        await db.productPositionChanges
            .where('magazineId').equals(this.magazineId)
            .and(field => field.pagePosition === this.pagePosition).delete();
        this.modified = false;
        await this.getPage();
      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden ", error);
      }
    },
  },
  async mounted() {

    window.crossApi.callbacks['pagepreview'] = (w, h) => {
      this.pagePreviewStyleObject = {
        height: h + 'px',
      };
    };
    const productPositions = await db.productPositionChanges
        .where('magazineId').equals(this.magazineId)
        .and(field => field.pagePosition === this.pagePosition).toArray();

    if (productPositions.length > 0) {
      this.modified = true;
    }
  },
  async created() {
    if (this.$isParamDefined('projectId')) {
      this.projectId = this.$route.params.projectId;
    }
    if (this.$isParamDefined('magazineId')) {
      this.magazineId = this.$route.params.magazineId;
    }
    if (this.$isParamDefined('pagePosition')) {
      this.pagePosition = this.$route.params.pagePosition;
    }
    if (this.$isParamDefined('marketId')) {
      this.marketId = this.$route.params.marketId;
    }

    this.$store.commit('setMagazineId', this.magazineId);
    this.$store.commit('setPagePosition', this.pagePosition);
    this.$store.commit('setMarketId', this.marketId);

    await this.getPage();
    await this.getTeamForUser();
    await this.getAllMarkets();

    // scheck if
    const productPositions = await  db.productPositionChanges
        .where('magazineId').equals(this.magazineId)
        .and(field => field.pagePosition === this.pagePosition).toArray();
    if (productPositions.length > 0) {
      this.modified = true;
    }
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.projectId = params.projectId;
        this.magazineId = params.magazineId;
        this.pagePosition = params.pagePosition;
        this.marketId = params.marketId;


        this.$store.commit('setMagazineId', this.magazineId);
        this.$store.commit('setPagePosition', this.pagePosition);
        this.$store.commit('setMarketId', this.marketId);
        if (this.marketId != null) {
          this.getPage();
          this.getAllMarkets();
        }
      },
      deep: true
    }
  }
}

</script>